<template>
  <div class="beer-style-slider-component">
    <BaseErrors :errors="errors"></BaseErrors>
    <BaseLoader :loading="loading"/>
    <br>
    <div id="sliders" v-if="beerSubStyle">

      <Slider slider-name="og"
              min-name="Low"
              max-name="High"
              range-name="OG (original gravity)"
              :min = 1.030
              :max = 1.1
              :recipe-value = "recipe.og"
              :range-min = "beerSubStyle.ogMin"
              :range-max = "beerSubStyle.ogMax"
      ></Slider>

      <Slider slider-name="fg"
              min-name="Low"
              max-name="High"
              range-name="FG (final gravity)"
              :min = 0.9
              :max = 1.050
              :recipe-value = "recipe.fg"
              :range-min = "beerSubStyle.fgMin"
              :range-max = "beerSubStyle.fgMax"
      ></Slider>

      <Slider slider-name="color"
              min-name="Pale"
              max-name="Dark"
              range-name="EBC (Color)"
              :min = 0
              :max = 100
              :recipe-value = "recipe.color"
              :range-min = "beerSubStyle.colorEbcMin"
              :range-max = "beerSubStyle.colorEbcMax"
      ></Slider>

      <Slider slider-name="bitterness"
              min-name="Low"
              max-name="High"
              range-name="IBU (Bitterness)"
              :min = 1
              :max = 100
              :recipe-value = "recipe.ibu"
              :range-min = "beerSubStyle.ibuMin"
              :range-max = "beerSubStyle.ibuMax"
      ></Slider>

      <Slider slider-name="alcohol"
              min-name="Low"
              max-name="High"
              range-name="% ABV (Alcohol)"
              :min = 2
              :max = 15
              :recipe-value = "parseFloat(recipe.abv)"
              :range-min = "beerSubStyle.abvMin"
              :range-max = "beerSubStyle.abvMax"
      ></Slider>

    </div>
  </div>
</template>

<script>
    import { HTTP } from '../lib/http';
    import { EventBus } from '../lib/event-bus.js';
    import Slider from '../components/bits/Slider';

    export default {
        name: "beer-style-slider-component",
        components: {
            Slider
        },
        props: {
            recipe: Object,
            beerSubStyleId: Number
        },
        data() {
            return {
                errors: null,
                loading: true,
                beerSubStyle: null
            };
        },
        watch: {
            beerSubStyleId(){
                this.fetchBeerStyle();
            }
        },
        methods: {
            fetchBeerStyle() {
                HTTP
                    .get('beer-sub-styles/' + this.beerSubStyleId)
                    .then(response => {
                        this.beerSubStyle = response.data.data;
                    })
                    .catch(err => {
                        this.errors = [err.response.data.errors];
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
        },

        beforeMount() {
            this.fetchBeerStyle();
        },
    };
</script>

<style scoped lang="scss">
  @import "/../assets/scss/_variablesx.scss";

</style>
